/**
 * Created by Holger Szuesz <development@szuesz.de> on 30.05.2019 15:48
 *
 */

import * as React from 'react';

import {Card, CardColumns} from "react-bootstrap";
import '../styles/Readinglist.css';
import {data} from "./data/readinglist";

class Readinglist extends React.Component<any> {
  public render() {
    return (
      <p className="App-intro">
        <CardColumns>
          {
            data.map((book) => {
              return (
                <Card key={book.id}>
                  <div className="card-blur-background" />
                  <Card.Body className="text-left">
                    <Card.Title>{book.title}</Card.Title>
                    <blockquote>
                      <footer className="blockquote-footer">
                        {book.author}
                      </footer>
                    </blockquote>
                    <Card.Text>{book.description}</Card.Text>
                  </Card.Body>
                </Card>
              );
            })
          }
        </CardColumns>
      </p>
    );
  }
}

export default Readinglist;



// WEBPACK FOOTER //
// ./src/components/Readinglist.tsx